export default __webpack_public_path__ + "static/media/toMarket.28f0e40a.svg";